import { ref } from 'vue'
import axios from 'axios'
import { formatDate, formatNumber } from '@/utils/text-utils'

export function useLiniesCampanya() {
  const campaignsLines = ref([])
  const quantitat = ref(0)
  const quantitat_distribuida = ref(0)
  const per_distribuida = ref(0)
  const headers = ref([
    { text: 'Distribución', value: 'estadoDistribucion', sortable: false },
    { title: 'Fecha de reparto', key: 'distribute_date' },
    { title: 'Provincia', key: 'zone_state_id' },
    { title: 'CP', key: 'zone_id' },
    { title: 'Municipio', key: 'zone_city' },
    { title: 'Zona', key: 'zone_reference' },
    { title: 'Cantidad', key: 'quantity', align: 'end'},
    { title: 'Tienda', key: 'shop', align: 'end'},
    { title: 'Hora inicio', key: 'hora_inici', align: ''},
    { title: 'Punto inicio', key: 'punt_inici', align: ''},
    { title: 'Ref. folleto', key: 'flyer_reference', align: 'left', sortable: true },
    { text: 'Mapa', value: 'mapa', sortable: false },
  ])

  // 🔹 Carrega línies d’una campanya
  const loadLinies = async (idCampanya, clientId, botigaId) => {
    const { data } = await axios.post('/api/ListLiniesCamp', {
      ClientId: clientId,
      id: idCampanya,
      BotigaId: botigaId
    })

    // Calcul de totals
    quantitat.value = data.reduce((acc, item) => acc + (item.quantity || 0), 0)
    quantitat_distribuida.value = data.reduce((acc, item) => acc + ((item.distributed && item.quantity) || 0), 0)
    per_distribuida.value = quantitat.value > 0 ? ((quantitat_distribuida.value / quantitat.value) * 100).toFixed(2) : 0

    const processed = data.map(camp => {
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      let estadoDistribucion = {
        color: 'grey',
        icon: 'mdi-help-circle',
        text: 'Desconocido'
      }

      if (!camp.distribute_date) {
        estadoDistribucion = {
          color: 'red',
          icon: 'mdi-calendar-remove',
          text: 'No planificado'
        }
      } else {
        const parsedDate = new Date(camp.distribute_date)
        parsedDate.setHours(0, 0, 0, 0)

        if (isNaN(parsedDate)) {
          estadoDistribucion = {
            color: 'red',
            icon: 'mdi-calendar-remove',
            text: 'Fecha no válida'
          }
        } else if (parsedDate.getTime() > today.getTime()) {
          estadoDistribucion = {
            color: 'orange',
            icon: 'mdi-calendar-clock',
            text: 'Planificado'
          }
        } else if (parsedDate.getTime() === today.getTime()) {
          estadoDistribucion = {
            color: 'blue',
            icon: 'mdi-mailbox-open-up-outline',
            text: 'En reparto'
          }
        } else if (parsedDate.getTime() < today.getTime()) {
          estadoDistribucion = {
            color: 'green',
            icon: 'mdi-mailbox-outline',
            text: 'Repartido'
          }
        }
      }

      return {
        ...camp,
        distribute_date: camp.distribute_date ? formatDate(camp.distribute_date) : '',
        quantity: formatNumber(camp.quantity),
        zone_state_id: Array.isArray(camp.zone_state_id) ? camp.zone_state_id[1] : camp.zone_state_id,
        zone_id: Array.isArray(camp.zone_id) ? camp.zone_id[1] : camp.zone_id,
        shop: Array.isArray(camp.shop) ? camp.shop[1] : (camp.shop || ''),
        estadoDistribucion
      }
    })

    campaignsLines.value = processed

    // 🔍 Si totes les línies tenen shop buit → eliminar columna
    const hasShopData = processed.some(item => item.shop && item.shop !== '')
    if (!hasShopData) {
      headers.value = headers.value.filter(h => h.key !== 'shop')
    }
  }

  return {
    campaignsLines,
    quantitat,
    quantitat_distribuida,
    per_distribuida,
    headers,
    loadLinies
  }
}
